import {api} from '../config/config';

export {api};

export const login = async (username, password) => {
    const response = await api.post("/api-token", { username, password });
    return response;
};


// Create a new user
export const createUser_MyProfile = async (user) => {
    const response = await api.post('/createUser_MyProfile', user);
    return response;
};


// users.js
export const activateUser = async (token) => {
  const response =  await api.get(`/activateUser/${token}`);
  return response;
};

export const forgottenPassword_reset_verify = async (token) => {
  const res= await api.get(`/forgottenPassword_reset_verify/${token}`);
  return res;
};

export const forgottenPassword_reset = async (token, password) => {
  const res= await api.post("/forgottenPassword_reset", {
    token,
    password: password,
  });
  return res;
};


export const forgottenPassword = async (data) => {
    const response = await api.post(`/forgottenPassword`, data);
    return response;
};

export const updateUser_MyProfile_Email = async (token) => {
    const response = await api.get(`/updateUser_MyProfile_Email/${token}`);
    return response;
};

// Get all groups
export const getGroups = async () => {
    
    const response = await api.get('/getGroups');

    return response;
};

// Get all objects
export const getObjects = async (options, service_url) => {
    const { filters, page, itemsPerPage, sortBy, sortDesc } = options;

    const response = await api.get('/'+service_url, {
      params: {
        filters: JSON.stringify(filters || []),
        pagen: page,
        itemsPerPage: itemsPerPage,
        sortBy: sortBy,
        sortDesc: sortDesc ? 'true' : 'false',
      },
    });

    return response;
};


// Create a new object
export const createObject = async (user, service_url) => {
    const response = await api.post('/'+service_url, user);
    return response;
};

// Update a object by ID
export const updateObject = async (parameter, service_url) => {
  const response = await api.post(`/`+service_url, parameter);
  return response;
};

// Delete a object by ID
export const deleteObject = async (id, service_url) => {
  const response = await api.post(`/${service_url}`, id);  return response;
};

export const exportObjects = async (payload, service_url) => {
  const { filters, page, itemsPerPage, sortBy, sortDesc } = payload;

    const res = await api.post(`/${service_url}`, payload);

    return res;
};


// exportFile_Bilan 
export const exportFile_Bilan = async (params, service_url) => {
    const response = await api.post(`/`+service_url, params, { responseType: 'arraybuffer' , headers: {
            'Content-Type': 'application/json',
          }});
    return response;
};

export const getElementsNavigation = (id, noId) => {
  return api.get("/getElements_Navigation", {
    params: { id, no_id: noId },
  });
};

// 
export const broadcast = async (parameter, service_url) => {
  const response = await api.post(`/`+service_url, parameter);
  return response;
};

// Upload a parameter
export const uploadParams = async (formData, service_url) => {
    const response = await api.post(`/`+service_url, formData);
    return response;
};


// Get all elements
export const getElements2 = async (options) => {
    const { filters, page, itemsPerPage, sortBy, sortDesc } = options;

    const response = await api.get('/getElements2', {
      params: {
        filters: JSON.stringify(filters || []),
        pagen: page,
        itemsPerPage: itemsPerPage,
        sortBy: sortBy,
        sortDesc: sortDesc ? 'true' : 'false',
      },
    });

    return response;
};


export const download_ = async () => {
    const res = await api.get(
      "/MonPetitTableurET/",{
      responseType: "blob", // important for binary files
    });

    return res;
};
// Export
export const exportParamsFile_fg = async (payload) => {
    const res = await api.post(
      "/Parameters_File_Generator",
      payload,
      { responseType: "blob" }
    );

    return res;
};

// Upload
export const uploadFile_fg = async (fd) => {
   const res = await api.post(
      "/Parameters_File_Generator_Import",
      fd
    );

    return res;
};


// Get a single user profile
export const getUserProfile = async (params) => {
    const response = await api.get(`/getUserProfile`, {
      params: params, 
    });
    return response;
};

// Upload profile image
export const uploadFileImage = async (formData, onUploadProgress) => {
    const response = await api.post(
      "/upload_photo_MyProfile",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress,
      }
    );
    return response;
};

/* ---------------- UPDATE PROFILE ---------------- */
export const updateUserProfile = async (user) => {
    const response = await api.post("/updateUser_MyProfile", user);
    return response;
};

/* ---------------- UPDATE EMAIL ---------------- */
export const updateUserEmail = async (email) => {
    const response = await api.post("/updateEmail_verif", { email });
    return response;
};

/* ---------------- UPDATE PASSWORD ---------------- */
export const updateUserPassword = async (password) => {
    const response = await api.post(
      "/updateUser_MyProfile_Password",
      { password }
    );
    return response;
};


// Create a new ticket
export const createTicket = async (ticket) => {
    const response = await api.post('/create_ticket', ticket);
    return response;
};

// Update a ticket by ID
export const updateTicket = async (ticket) => {
    const response = await api.post(`/update_ticket`, ticket);
    return response;
};

// Update a ticket by ID
export const updateTicketUser = async (user_ticket) => {
    const response = await api.post(`/update_user_ticket`, user_ticket);
    return response;
};

// Delete a ticket by ID
export const deleteTicket = async (id) => {
    const response = await api.post(`/delete_ticket`, id);
    return response;
};

/* ---------------- GET MESSAGES ---------------- */
export const getMessages = async (params) => {
    const response = await api.get("/get_Messages", { params });
    return response;
};

// Get a single Message by ID
export const getMessage = async (id) => {
    const response = await api.get(`/getMessage/${id}`);
    return response;
};

// Create a new message
export const createMessage = async (message) => {
    const response = await api.post('/create_message', message);
    return response;
};

// Update a ticket by ID
export const updateMessage = async (message) => {
    const response = await api.post(`/update_message`, message);
    return response;
};

// Delete a ticket by ID
export const deleteMessage = async ({ id, ticket_id }) => {
    const response = await api.post(`/delete_message`, { id, ticket_id });
    return response;
};